import React from 'react';
import { DashboardWrapper } from '@screens/Dashboard';
import {
  Discovery,
  DiscoveryMutualFund,
  DiscoveryStock,
  CalendarDiscovery,
  // IPODetail,
  EIPODetail,
  HighlightDetail,
  // LazyIPOForm,
} from '@screens/Discovery';
// import {
//   Transaction,
//   TransactionMutualFund,
//   TransactionDayTrading,
//   TransactionFreeStock,
//   TransactionMarginTrading,
// } from '@screens/Transaction';
import { Portfolio } from '@screens/Portfolio';
import { PnL } from '@screens/PnL';
import { StockDetail } from '@screens/StockDetail';
import News from '@screens/News';
import { MfDetail, MfWithdraw, MfDeposit } from '@screens/MutualFundDetail';
import TradingView from '@screens/TradingView';
import CompareFund from '@screens/CompareFund';
import TopPerformer from '@screens/TopPerformer';
// import TransactionAutoOrderV2 from '@screens/Transaction/TransactionAutoOrderV2';

/**
 * @type {import('react-router-dom').RouteObject}
 */
const homeRoutes = [
  {
    index: true,
    element: <DashboardWrapper />,
  },
  {
    path: 'market-index',
    element: <Discovery />,
  },
  { path: 'mutual-funds', element: <DiscoveryMutualFund /> },
  { path: 'news', element: <News /> },
  { path: 'portofolio', element: <Portfolio /> },
  { path: 'reksadana/:id', element: <MfDetail /> },
  { path: 'reksadana/:id/tarik', element: <MfWithdraw /> },
  { path: 'reksadana/:id/setor', element: <MfDeposit /> },
  { path: 'saham/:code', element: <StockDetail /> },
  { path: 'stocks', element: <DiscoveryStock /> },
  { path: 'stocks/highlight/:code', element: <HighlightDetail /> },
  // TODO: remove IPO after EIPO is stable */}
  // <Route exact path="/stocks/IPO/:code" element={<IPODetail} />
  // { path: '/stocks/IPO/:code/form', element: <LazyIPOForm /> },
  { path: 'stocks/IPO/:id', element: <EIPODetail /> },
  { path: 'top-performer', element: <TopPerformer /> },
  { path: 'trading-view/:code', element: <TradingView /> },
  // { path: 'transaction-stock', element: <Transaction /> },
  // { path: 'transaction-mutual-funds', element: <TransactionMutualFund /> },
  // { path: 'transaction-auto-order', element: <TransactionAutoOrderV2 /> },
  // { path: 'transaction-free-stock', element: <TransactionFreeStock /> },
  // { path: 'transaction-margin-trading', element: <TransactionMarginTrading /> },
  // { path: 'transaction-day-trading', element: <TransactionDayTrading /> },
  { path: 'compare-fund', element: <CompareFund /> },
  { path: 'calendar', element: <CalendarDiscovery /> },
  { path: 'pnl', element: <PnL /> },
  // <Route exact path="/trading-view-ihsg" element={<TradingViewIHSG} /> */}
];

export default homeRoutes;
